import React from 'react';
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";

export const Tab = () => {
  return (
    <>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <NavLink to={`/admin/equipment/equipment`} onClick={scrollTo} className="nav-link">
            <i className="fa-solid fa-shirt me-1"/> Equipements
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to={`/admin/equipment/size`} onClick={scrollTo} className="nav-link">
            <i className="fa-solid fa-up-right-and-down-left-from-center me-1"/> Tailles
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to={`/admin/equipment/collection`} onClick={scrollTo} className="nav-link">
            <i className="fas fa-shopping-bag me-1"/> Collections
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to={`/admin/equipment/body-area`} onClick={scrollTo} className="nav-link">
            <i className="fa-solid fa-person me-1"/> Zone du corps
          </NavLink>
        </li>
      </ul>
    </>
  );
}
